import { loanApplicationBorrowersApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_APPLICATION_BORROWERS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/borrowers`,
  {
    GET_BORROWERS_TABLE_DATA: 'GET_BORROWERS_TABLE_DATA',
  },
);

export const getBorrowersTableDataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanApplicationBorrowersApi.getBorrowersTableData(params);

  return dispatch({
    type: LOAN_APPLICATION_BORROWERS_ACTION_TYPE.GET_BORROWERS_TABLE_DATA,
    payload: data,
  });
});

export const getBorrowersInfoAction = catchAsyncActionError(params => async () => {
  const { data } = await loanApplicationBorrowersApi.getBorrowersInfo(params);

  return data;
});
